<div class="max-w-[570px] bg bg-off-white rounded-12px px-[49px] py-[37px]">
	<div class="flex justify-end mb-[13px]">
		<img alt="" src="./assets/images/close-square.svg" />
	</div>
	<p
		class="text-center text-[24px] ltr:font-DIN-bold font-bold rtl:font-semibold text-dark-grey leading-[26px] mb-24px"
	>
		{{ 'ORGANIZATION.LIST_POPUP.CHOOSE_ACCOUNT' | translate }}
	</p>
	<section class="overflow-x-scroll flex pb-[10px] scrollbar-none mb-36px">
		<div
			class="shrink-0 py-[28px] px-12px text-center max-w-[150px] max-h-[211px] border-[1px] border-solid border-secondry-color-Gray rounded-[12px] mr-[6px] rtl:ml-[6px] rtl:mr-[0px]"
		>
			<img
				alt=""
				class="rounded-full max-w-[56px] m-auto mb-12px"
				src="./assets/images/logo.png"
			/>
			<app-status [enumData]="statusEnum" [statusValue]="true"></app-status>
			<p
				class="text-font-16 ltr:font-DIN-bold font-bold rtl:font-semibold text-dark-grey mb-[3px]"
			>
				Business name
			</p>
			<p class="text-font-12 text-medium-gray m-0">BUSINESS TYPE</p>
			<p class="text-font-12 text-medium-gray m-0">COUNTRY</p>
		</div>
		<div
			class="shrink-0 py-[28px] px-12px text-center max-w-[150px] max-h-[211px] border-[1px] border-solid border-secondry-color-Gray rounded-[12px] mr-[6px] rtl:ml-[6px] rtl:mr-[0px]"
		>
			<img
				alt=""
				class="rounded-full max-w-[56px] m-auto mb-12px"
				src="./assets/images/logo.png"
			/>
			<app-status [enumData]="statusEnum" [statusValue]="true"></app-status>
			<p
				class="text-font-16 ltr:font-DIN-bold font-bold rtl:font-semibold text-dark-grey mb-[3px]"
			>
				Business name
			</p>
			<p class="text-font-12 text-medium-gray m-0">BUSINESS TYPE</p>
			<p class="text-font-12 text-medium-gray m-0">COUNTRY</p>
		</div>
		<div
			class="shrink-0 py-[28px] px-12px text-center max-w-[150px] max-h-[211px] border-[1px] border-solid border-secondry-color-Gray rounded-[12px] mr-[6px] rtl:ml-[6px] rtl:mr-[0px]"
		>
			<img
				alt=""
				class="rounded-full max-w-[56px] m-auto mb-12px"
				src="./assets/images/logo.png"
			/>
			<app-status [enumData]="statusEnum" [statusValue]="true"></app-status>
			<p
				class="text-font-16 ltr:font-DIN-bold font-bold rtl:font-semibold text-dark-grey mb-[3px]"
			>
				Business name
			</p>
			<p class="text-font-12 text-medium-gray m-0">BUSINESS TYPE</p>
			<p class="text-font-12 text-medium-gray m-0">COUNTRY</p>
		</div>
		<div
			class="shrink-0 py-[28px] px-12px text-center max-w-[150px] max-h-[211px] border-[1px] border-solid border-secondry-color-Gray rounded-[12px] mr-[6px] rtl:ml-[6px] rtl:mr-[0px]"
		>
			<img
				alt=""
				class="rounded-full max-w-[56px] m-auto mb-12px"
				src="./assets/images/logo.png"
			/>
			<app-status [enumData]="statusEnum" [statusValue]="true"></app-status>
			<p
				class="text-font-16 ltr:font-DIN-bold font-bold rtl:font-semibold text-dark-grey mb-[3px]"
			>
				Business name
			</p>
			<p class="text-font-12 text-medium-gray m-0">BUSINESS TYPE</p>
			<p class="text-font-12 text-medium-gray m-0">COUNTRY</p>
		</div>
		<div
			class="shrink-0 py-[28px] px-12px text-center max-w-[150px] max-h-[211px] border-[1px] border-solid border-secondry-color-Gray rounded-[12px] mr-[6px] rtl:ml-[6px] rtl:mr-[0px]"
		>
			<img
				alt=""
				class="rounded-full max-w-[56px] m-auto mb-12px"
				src="./assets/images/logo.png"
			/>
			<app-status [enumData]="statusEnum" [statusValue]="true"></app-status>
			<p
				class="text-font-16 ltr:font-DIN-bold font-bold rtl:font-semibold text-dark-grey mb-[3px]"
			>
				Business name
			</p>
			<p class="text-font-12 text-medium-gray m-0">BUSINESS TYPE</p>
			<p class="text-font-12 text-medium-gray m-0">COUNTRY</p>
		</div>
	</section>
	<button
		class="w-full text-off-white bg-gradient py-[10px] px-24px rounded-6px"
	>
		{{ 'ACTIONS.CHOOSE' | translate }}
	</button>
</div>
